<template>
    <a v-if="link" type="button" :href="link" :class="classes"><slot></slot></a>
    <button v-else type="button" :class="classes"><slot></slot></button>
</template>

<script>
export default {
    name: "AlphaButton",
    props: {
        color: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'sm'
        },
        link: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            return ['btn', 'btn-icon', `btn-${this.size}`, `alpha-${this.color}`, `text-${this.color}-800`, this.disabled ? 'disabled' : '', 'legitRipple']
        }
    }
}
</script>

<style scoped>
</style>
